import { VStack } from "@chakra-ui/react"
import React from "react"
import { ExtendUserRoleForm } from "../../forms"
import { UserRoleFragment } from "../../graphql"

export type ExtendUserRoleProps = {
	userId: string
	userRole: UserRoleFragment
}

export const ExtendUserRole: React.FC<ExtendUserRoleProps> = ({ userId, userRole }) => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<ExtendUserRoleForm userId={userId} userRole={userRole} />
		</VStack>
	)
}
